import { cn } from "@/lib/utils";
import { ReactNode, useState } from "react";

interface ComprarTitulosCarouselProps {
    initialSlide?: number;
    principalContent: ReactNode;
    giroContent: ReactNode;
}

const SLIDES = [
    { id: 0, label: "Principal" },
    { id: 1, label: "Giro" },
] as const;

export function ComprarTitulosCarousel({
    initialSlide = 0,
    principalContent,
    giroContent,
}: ComprarTitulosCarouselProps) {
    const [slideAtivo, setSlideAtivo] = useState(initialSlide);

    return (
        <div className="flex flex-col w-full px-2 md:px-5">
            <div className="flex items-end justify-center gap-1">
                {SLIDES.map((slide) => {
                    const ativo = slideAtivo === slide.id;
                    return (
                        <button
                            key={slide.id}
                            type="button"
                            onClick={() => setSlideAtivo(slide.id)}
                            className={cn(
                                "relative z-10 min-w-[7.5rem] rounded-t-lg border-2 border-b-0 px-4 py-2 text-sm font-semibold transition-colors",
                                ativo
                                    ? "-mb-[2px] border-yellow-400 bg-yellow-400 text-foreground"
                                    : "border-transparent bg-muted/70 text-muted-foreground hover:bg-muted hover:text-foreground"
                            )}
                            aria-pressed={ativo}
                        >
                            {slide.label}
                        </button>
                    );
                })}
            </div>

            <div className="relative w-full overflow-hidden rounded-b-xl rounded-tr-xl border-2 border-yellow-400 bg-background p-3 md:p-4">
                {slideAtivo === 0 ? principalContent : giroContent}
            </div>
        </div>
    );
}
